const state = () => ({
	historyEntries: []
});


const getters = {
	getHistoryEntries (state) {
		return state.historyEntries;
	}
};
const mutations = {
	setHistoryEntries (state, history) {
		state.historyEntries = history;
	}
};



export default {
	namespaced: true,
	state,
	mutations,
	getters
};
